// import COSSDK from "cos-js-sdk-v5";

import { SDKAppID, SDKAppID_IM } from "@match/config";

export default function initTim() {
  let tim = null;
  var SDKAppID = SDKAppID_IM;
  // 初始化 SDK 实例
  tim = window.TIM.create({
    SDKAppID
  });
  window.setLogLevel = tim.setLogLevel;

  // 无日志级别
  tim.setLogLevel(3);

  // 注册 cos
  // tim.registerPlugin({ "cos-js-sdk": COSSDK });
  //static cos-js-sdk-v4.js
  return tim;
}



// WEBPACK FOOTER //
// ./src/common/tim.js